import * as React from 'react';
import {ReactNode} from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {LinearProgress} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {icons} from '../../../components/Ui/icons';

export interface DialogTitleProps {
    children?: React.ReactNode;
}

export const AppDialogTitle = (props: DialogTitleProps) => {
    const {children, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            <div
                style={{
                    paddingRight: 30,
                }}
            >
                {children}
            </div>
        </DialogTitle>
    );
};

type ActionArgs = {
    onClose: () => void;
    loading?: boolean;
    loadingProgress?: number;
};

type Props = {
    title?: ReactNode;
    actions?: (args: ActionArgs) => React.ReactNode;
    children?: React.ReactNode;
} & ActionArgs;

export type {Props as AppDialogContentProps};

export default function AppDialogContent({
    title,
    children,
    actions,
    loading,
    loadingProgress,
    onClose,
}: Props) {
    const progressHeight = 3;

    const args = {
        onClose,
        loading,
        loadingProgress,
    };

    return (
        <>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500],
                    }}
                >
                    <icons.close />
                </IconButton>
            ) : null}
            {title && <AppDialogTitle>{title}</AppDialogTitle>}
            <DialogContent dividers>{children}</DialogContent>
            {loading && (
                <LinearProgress
                    variant={
                        typeof loadingProgress === 'number'
                            ? 'determinate'
                            : undefined
                    }
                    value={loadingProgress}
                    style={{
                        height: progressHeight,
                        marginBottom: -progressHeight,
                    }}
                />
            )}
            {actions && <DialogActions>{actions(args)}</DialogActions>}
        </>
    );
}
